import { SeekCalculationInput, VideoDetails } from './types'

const LIVE_MATCHER = /live/i

const clamp = (value: number, min: number, max: number): number => {
  if (value < min) {
    return min
  }
  if (value > max) {
    return max
  }
  return value
}

export const isVodContent = (details?: VideoDetails): boolean => {
  if (!details) {
    return true
  }
  const contentType = details.contentType ?? ''
  const relatedType = details.relatedAssetVideoType ?? ''
  const isContentLive = LIVE_MATCHER.test(contentType)
  const isRelatedLive = LIVE_MATCHER.test(relatedType)
  return !(isContentLive || isRelatedLive)
}

export const calculateSeekTimeFromPointer = ({
  clientX,
  left,
  width,
  duration,
}: SeekCalculationInput): number => {
  if (duration <= 0 || width <= 0) {
    return 0
  }
  const relativeX = clamp(clientX - left, 0, width)
  const progressFraction = relativeX / width
  return clamp(progressFraction * duration, 0, duration)
}
